import { Request } from './Request';

export interface IGetTokenParams {
}

export interface IGetTokenResult {
  refreshTokenCount: number;
}

export class GetTotalRefreshTokenCountRequest extends Request<IGetTokenParams, IGetTokenResult> {
  constructor(params: IGetTokenParams) {
    super('getTotalRefreshTokenCount', params);
  }
}
